import * as FullStory from '@fullstory/browser';

interface FSClient {
  anonymize(): void;

  consent(userConsents?: boolean): void;

  event(eventName: string, eventProperties: { [key: string]: any }): void;

  identify(uid: string, customVars?: Bluebeam.Analytics.Models.UserVars): void;

  isInitialized(): boolean;

  log(level: Bluebeam.Analytics.Models.LogLevel, msg: string): void;

  log(msg: string): void;

  restart(): void;

  setUserVars(customVars: Bluebeam.Analytics.Models.UserVars): void;

  shutdown(): void;

  setVars(
    varScope: Bluebeam.Analytics.Models.VarScope,
    properties?: { [key: string]: any }
  ): void;
}

export class FullstoryAnalyticsService
  implements Bluebeam.Services.IAnalyticsService
{
  private readonly _client: FSClient;

  private _state: 'unknown' | 'initializing' | 'active' | 'inactive' =
    'unknown';

  private constructor(fsClient: FSClient, sessionUrl: string) {
    this._client = fsClient;
    this._state = 'active';
  }

  public static Init(
    options: Bluebeam.Analytics.Models.SnippetOptions
  ): Promise<FullstoryAnalyticsService> {
    return new Promise((resolve) => {
      FullStory.init(
        {
          ...options,
        },
        ({ sessionUrl }: { sessionUrl: string }) => {
          resolve(new FullstoryAnalyticsService(FullStory, sessionUrl));
        }
      );
    });
  }

  anonymize(): void {
    this._client.anonymize();
  }

  consent(userConsents?: boolean): void {
    this._client.consent(userConsents);
  }

  event(eventName: string, eventProperties: { [p: string]: any }): void {
    this._client.event(eventName, eventProperties);
  }

  identify(uid: string, customVars?: Bluebeam.Analytics.Models.UserVars): void {
    this._client.identify(uid, customVars);
  }

  isInitialized(): boolean {
    return this._client.isInitialized();
  }

  restart(): void {
    this._client.restart();
    this._state = 'active';
  }

  shutdown(): void {
    this._client.shutdown();
    this._state = 'inactive';
  }

  currentStateIs(
    state: 'unknown' | 'initializing' | 'active' | 'inactive'
  ): boolean {
    return this._state === state;
  }

  getCurrentState(): 'unknown' | 'initializing' | 'active' | 'inactive' {
    return this._state;
  }
}
